// JavaScript Document
//components/configuration/ConfigStandard.js
import React from 'react';
//import PropTypes from 'prop-types';
//import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import AddIcon from '@material-ui/icons/AddCircle';
import Popover from '@material-ui/core/Popover';
import SettingPicker from '../forms/SettingPicker';
import dsutils from './Utils';
const utils = dsutils();

/*
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
	pos: {
		marginBottom:12,
	},
}));
*/

export default function FlatSetting(props) {
  	//const classes = useStyles();
	//Inherited props
  	const {settings, onChange, type} = props;
  	const [times, setTimes] = React.useState([{time: '00:00:00', value:99}]);
	//Initialize popover state
	const [timePop, setTimePop] = React.useState({
		anchor: null,
		open: false,
		time: '00:00:00',
		value: 99
	});
	//Open Setting Popper on add chip click
	const addTime = (e) => {
		let time = '00:00:00';
		let value = 99;
		if(times.length > 0){
			time = times[times.length -1].time;
			value = times[times.length - 1].value;
		}
		setTimePop({
			anchor: e.currentTarget,
			open: true,
			time: time,
			value: value
		});
	}
	//Close setting time popper
	const closePop = () => {
		setTimePop({
			anchor: null,
			open : false,
			time: '00:00:00',
			value: 99
		});
	}
	//Get time and value from SettingPicker and add to array
	const handleAddTime = (time, value) => {
		//let newTimes = Object.assign([], times);
		let newTimes = utils.control.setting.insert({time: time, value:value}, times);
		//newTimes.push({time: time, value: value});
		setTimes(newTimes);
		if(onChange){
			onChange(newTimes, type);
		}
		closePop();
	}
	//handle delete chip button click
	const handleDelTime = (e, i) => {
		let newTimes = Object.assign([], times);
		newTimes.splice(i, 1);
		//update local
		setTimes(newTimes);
		//update parent, if available
		if(onChange){
			onChange(newTimes, type);
		}
	}
	//Compile the add button chip
	const addButton = () =>{
		if(times.length < 6){
			return (
				<Chip label="Add" icon={<AddIcon />} variant="outlined" onClick={addTime} /> 
			);
		}
		return '';
	};
	const displayText = (setting) => {
		return setting.value+" at "+utils.control.time.pretty(setting.time);
	};
	const settingTimes = () => {
		if(times.length === 0){
			return (
				<div>
				<Chip label="None" />
				{addButton()}
				</div>
			);
		} else {
			return (
				<div>
				{times.map((row, i) => (
				 	<Chip
				 		key={i}
						label={displayText(row)}
						onDelete={(e) => {handleDelTime(e, i)}}
					/>
				 ))}
				 {addButton()}
				</div>
			);
		}
	};
	//Update UI on props change
	React.useEffect(() => {
		setTimes(settings);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
  return (
    <div>
	  {settingTimes()}
	  <Popover
					id={type+'powerpopper'}
					open={timePop.open}
					anchorEl={timePop.anchor}
					onClose={closePop}
					anchorOrigin={{
								  vertical:'bottom',
								  horizontal: 'center'
								 }}
					transformOrigin={{
									 vertical:'top',
									 horizontal:'center'
									}}
				>
				<SettingPicker time={timePop.time} value={timePop.value} onChange={handleAddTime} type={type} />
			</Popover>
    </div>
  );
}
